import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, imgUrl } from "@/lib/api";
import { BookCover } from "@/components/BookCover";
import { ArticleCard } from "@/components/ArticleCard";
import { KnotDivider, FrameCorners } from "@/components/ornaments";
import { PageState } from "@/pages/PageState";
import { useT } from "@/lib/labels";

export default function SeriesPage() {
  const { slug } = useParams();
  const [s, setS] = useState(undefined);
  const t = useT();
  useEffect(() => { setS(undefined); api.get(`/series/${slug}`).then((r) => setS(r.data)).catch(() => setS(null)); }, [slug]);
  if (!s) return <PageState loading={s === undefined} />;
  const n = s.books.length;

  return (
    <div data-testid="series-page" className="max-w-7xl mx-auto px-6 sm:px-8 py-12">
      <nav className="text-sm font-heading text-[#5e4a35] mb-8"><Link to="/" className="hover:text-[#991b1b]">Home</Link> <span className="mx-2">›</span> Chronicles</nav>
      {s.banner_image && (
        <div className="relative vellum gilt p-3 mb-12 rise">
          <FrameCorners />
          <img src={imgUrl(s.banner_image)} alt="" className="w-full h-56 sm:h-80 object-cover" />
        </div>
      )}
      <div className="grid lg:grid-cols-12 gap-8 rise">
        <div className="lg:col-span-7">
          {t("series.eyebrow") && <p className="eyebrow">{t("series.eyebrow")}</p>}
          <h1 data-testid="series-title" className="font-display text-4xl sm:text-5xl lg:text-6xl mt-2">{s.title}</h1>
        </div>
        <div className="lg:col-span-5 lg:pt-8">
          <p className="text-lg leading-relaxed">{s.description}</p>
          <p data-testid="series-volume-count" className="mt-4 font-heading text-sm text-[#1e4976]">{n} {n === 1 ? "volume" : "volumes"} published{s.planned_books ? ` · ${s.planned_books} planned` : ""}</p>
        </div>
      </div>
      <KnotDivider className="my-14" />
      {n === 0 ? <p className="italic text-[#5e4a35]">The first volume is yet to be inscribed.</p> : (
        <div data-testid="series-books-grid" className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8">
          {s.books.map((b, i) => <BookCover key={b.id} book={b} index={i} />)}
        </div>
      )}
      {s.articles?.length > 0 && (
        <>
          <KnotDivider className="my-14" />
          {t("series.lore_eyebrow") && <p className="eyebrow">{t("series.lore_eyebrow")}</p>}
          {t("series.lore_title") && <h2 className="font-display text-3xl mt-2 mb-8">{t("series.lore_title")}</h2>}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">{s.articles.map((a, i) => <ArticleCard key={a.id} a={a} index={i} />)}</div>
        </>
      )}
    </div>
  );
}
